// Go to next page after completing a prepost
// - /survey if you're a normal user
// - /dashboard if you're a manager
import history from '../history';

export const nextPage = () => {
  const isManager = sessionStorage.getItem('isManager') === 'true';
  history.push(isManager ? '/dashboard' : '/survey');
};
